const algoliasearch = require('algoliasearch/lite')

function algolia(index) {
  switch (index) {
    case 'showcases':
    case 'tutorials':
    case 'starters':
    case 'community_stars':
      return algoliasearch(
        process.env.ALGOLIA_APP_ID,
        process.env.ALGOLIA_API_KEY
      ).initIndex(index)
    default:
      return algoliasearch(
        process.env.ALGOLIA_ARTICLES_APP_ID,
        process.env.ALGOLIA_ARTICLES_API_KEY
      ).initIndex(index)
  }
}

module.exports = algolia
